import PaymentsList from './list-payments.tsx';

export default function SecondOpinionPayments() {
  return <PaymentsList type="second_opinion" title="Second Opinion Payments" />;
}
